import { generateAssets } from "@/utils/GenerateAssets.ts";

export const commonSoundsBundle = {
    button_click_1: { alias: "button_click_1", src: "audio/student/sfx/button_click_1.mp3" },
    button_click_2: { alias: "button_click_2", src: "audio/student/sfx/button_click_2.mp3" },
    // Add new sounds here
};

export const CommonSounds = generateAssets(commonSoundsBundle);

// Now you can use the sounds object with type checking
// console.log(CommonSounds.button_click_1); // Outputs: "button_click_1"